import { Slider } from '@/components/ui/slider';
import { formatAmount, useLocaleStore } from '@/lib/core';

export interface FilterPriceRangeProps {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
}

export function FilterPriceRange({ min, max, value, onChange }: FilterPriceRangeProps) {
  const locale = useLocaleStore(state => state.locale);

  return (
    <div className="flex flex-col gap-4 py-3">
      <Slider
        min={min}
        max={max}
        step={1}
        value={value}
        onValueChange={next => onChange([next[0] ?? min, next[1] ?? max])}
      />
      <div className="flex items-center justify-between">
        <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] tracking-[0.5px]">
          {formatAmount(value[0], 'EUR', locale)}
        </span>
        <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] tracking-[0.5px]">
          {formatAmount(value[1], 'EUR', locale)}
        </span>
      </div>
    </div>
  );
}
